// RequireNoneAuth.jsx
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Redirect from '../container/Redirect.js';

import { reduxStoreInitializePromise } from '../resource/reduxStoreInitializePromise.js';

export const RequireNoneAuth = ({
  isAuthed,
  token,
  handleLoginToken,
  children,
}) => {
  const [isReduxStoreInitialized, setIsReduxStoreInitialized] = useState(false);

  useEffect(() => {
    // If you would like to use RequireNoneAuth on Next,
    // ensure that you put <RequireNoneAuth> in layout instead of page.
    // Otherwise, it causes rsc reload,
    // and `isReduxStoreInitialized` would be false and then true again after reload.
    reduxStoreInitializePromise.then(() => setIsReduxStoreInitialized(true));
  }, []);

  useEffect(() => {
    if (isReduxStoreInitialized && !isAuthed && token) {
      handleLoginToken({ token });
    }
  }, [isReduxStoreInitialized, isAuthed, token, handleLoginToken]);

  if (isAuthed && isReduxStoreInitialized) return <Redirect to="/" />;

  return (
    <div className="RequireNoneAuth">
      {token || !isReduxStoreInitialized ? 'Verifying...' : children}
    </div>
  );
};

RequireNoneAuth.propTypes = {
  children: PropTypes.element.isRequired,
  isAuthed: PropTypes.bool.isRequired,
  token: PropTypes.string,
  handleLoginToken: PropTypes.func.isRequired,
};

export default RequireNoneAuth;
